export const userProfileQuery = `
query ($data: InputQueryFilter_ProfileDto) {
  userQueries {
    profile(filter: $data) {
      listDto {
        items {
          id
          userName
          fullName
          forceChangePassword
          forceCompleteProfile
          phoneNumber
          nationalCode
          birthDate
          lastLoginDateTime
          oneToLastLoginDateTime
          avatarUrl
          roleDtos {
            id
            name
          }
        }
      }
    }
  }
}
`